/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_Author_FieldInputs */

const en_admin_posts_author_field = /** @type {(inputs: Admin_Posts_Author_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Author`)
};

/**
* | output |
* | --- |
* | "Author" |
*
* @param {Admin_Posts_Author_FieldInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_posts_author_field = /** @type {((inputs?: Admin_Posts_Author_FieldInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_Author_FieldInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_posts_author_field(inputs)
});
export { admin_posts_author_field as "admin.posts.author_field" }